import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "upgrade",
  "use": "upgrade-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"upgrade\"><defs><style>#upgrade .cls-1{fill:none}</style></defs><title>资源 52</title><g id=\"upgrade_图层_2\" data-name=\"图层 2\"><g id=\"upgrade_图层_1-2\" data-name=\"图层 1\"><path id=\"upgrade_Rectangle_48_Copy_30\" data-name=\"Rectangle 48 Copy 30\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"upgrade_totop\"><path id=\"upgrade_Shape\" d=\"M2.44 21.28a.84.84 0 0 1-.82-.87.86.86 0 0 1 .82-.82h19.12a.85.85 0 1 1 0 1.69H2.44zm8.72-5.16V5.6l-2 2a.86.86 0 0 1-.6.25A.84.84 0 0 1 8 6.4L11.4 3a.84.84 0 0 1 1.19 0L16 6.4a.85.85 0 0 1 0 1.2.86.86 0 0 1-1.2 0l-2-2v10.52a.84.84 0 0 1-1.68 0z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/upgrade.svg
// module id = hgk7
// module chunks = 6